// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3tHNv","vLegacy":"SelectSecondary_vLegacy__1x1-E","error":"SelectSecondary_error__1VOTX","disabled":"SelectSecondary_disabled__2lN5W"};